import diff_match_patch from 'diff-match-patch'

const dmp = new diff_match_patch.diff_match_patch()

const patchApply = (diffs, text) =>{
    return dmp.patch_apply(dmp.patch_fromText(diffs), text)[0];
};

export {dmp, patchApply}
